import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackBarComponent } from '@dal/shared-ui';

export type SnackbarType = 'success' | 'error' | 'warning' | 'info';
@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private _snackBar:MatSnackBar) { }

  open(
    message = '',
    type: SnackbarType = 'success',
    action = '',
    duration = 5,
    horizontalPosition: MatSnackBarHorizontalPosition = 'end',
    verticalPosition: MatSnackBarVerticalPosition = 'top',): void {

    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: (duration || 5) * 1000,
      data: { message: message, action: action },
      panelClass: [`${type}-snackbar`],
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
    });
  }
}